// Landing page settings. Leave a value as "" and that feature switches off.
window.SITE_CONFIG = {
  brandName: "Reset Supply",

  // HubSpot Meetings scheduling link
  meetingUrl: "https://meetings-na2.hubspot.com/manager-team",

  // Walkthrough video shown after booking. YouTube/Vimeo/Loom *embed* URL
  videoEmbedUrl: "",

  // Meta Pixel ID
  metaPixelId: "2363946504419726",

  // HubSpot portal and Start Now application form
  hubspotPortalId: "247020494",
  hubspotApplicationFormGuid: "8bb0d63e-d850-441c-a564-ebe6e819d996",
};
